export const POSITION_MANAGER_API = 'https://vault.pancakeswap.com/api/statistics'
